/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\Equipment\EquipmentList.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Tuesday March 26th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday March 26th 2024 10:29:36 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper"
import { CarEquipmentType } from "Type/singleCarDbType";
import Styles from "Content/Equipment/EquipmentList.module.css";
import { UpdateCarType } from "Type/CarElement.type.hold";
import { Equipment } from "./Equipment";
import { CreateEquipment } from "./CreateEquipment";
import { useEffect, useState } from "react";

type EquipmentListProps = {
    carUpdate: UpdateCarType;
    equipmentList?: CarEquipmentType[];
    title: string;
    disabled: boolean;
};

export function EquipmentList(props: EquipmentListProps) {
    const [equipmentToAdd, setEquipmentToAdd] = useState<CarEquipmentType[]>([]);
    const [equipment, setEquipment] = useState<CarEquipmentType[]>();

    useEffect(() => {
        setEquipment(props.equipmentList);
    }, [props.equipmentList]);

    const manageStatusToDelete = (id: string, status: boolean) => {
        if (equipment) {
            const toDelete = equipment.filter(item => item.id === id);
            if (toDelete.length !== 0)
                toDelete[0].toDelete = status;
            setEquipment([...equipment]);
        }
    };

    const cleanCarUpdate = () => {
        if (props.carUpdate.create.EquipmentsToCreate && props.carUpdate.create.EquipmentsToCreate.length === 0)
            props.carUpdate.create.EquipmentsToCreate = undefined;
        if (props.carUpdate.update.EquipmentsToUpdate && props.carUpdate.update.EquipmentsToUpdate.length === 0)
            props.carUpdate.update.EquipmentsToUpdate = undefined;
        if (props.carUpdate.delete.EquipmentsToDelete && props.carUpdate.delete.EquipmentsToDelete.length === 0)
            props.carUpdate.delete.EquipmentsToDelete = undefined;
    };

    const handleDeletEquipment = (id: string, isNew?: boolean) => {
        if (isNew && props.carUpdate.create.EquipmentsToCreate) {
            const idx = props.carUpdate.create.EquipmentsToCreate.findIndex(item => item.id === id);
            props.carUpdate.create.EquipmentsToCreate.splice(idx,1);
            const idxArr = equipmentToAdd.findIndex(item => item.id === id);
            equipmentToAdd.splice(idxArr, 1);
            setEquipmentToAdd([...equipmentToAdd]);
        } else {
            if (props.carUpdate.update.EquipmentsToUpdate) {
                const idx = props.carUpdate.update.EquipmentsToUpdate.findIndex(item => item.id === id);
                if (idx !== -1)
                    props.carUpdate.update.EquipmentsToUpdate.splice(idx, 1);
            }
            if (!props.carUpdate.delete.EquipmentsToDelete)
                props.carUpdate.delete.EquipmentsToDelete = [];
            if (!props.carUpdate.delete.EquipmentsToDelete.includes(id)) {
                props.carUpdate.delete.EquipmentsToDelete.push(id);
                manageStatusToDelete(id, true);
            }
        }
        props.carUpdate.update.updated = true;
        cleanCarUpdate();
    };

    const handleValidEquipment = (id: string, input: string) => {
        if (props.carUpdate.delete.EquipmentsToDelete && props.carUpdate.delete.EquipmentsToDelete.includes(id)) {
            const idxArr = props.carUpdate.delete.EquipmentsToDelete.findIndex(item => item === id);
            props.carUpdate.delete.EquipmentsToDelete.splice(idxArr, 1);
            const origin = props.equipmentList?.filter((item: any) => item.id === id);
            if (input !== "" && origin?.length == 1 && origin[0].Name !== input) {
                if (!props.carUpdate.update.EquipmentsToUpdate)
                    props.carUpdate.update.EquipmentsToUpdate = [];
                props.carUpdate.update.updated = true;
                props.carUpdate.update.EquipmentsToUpdate.push({Name: input, id: id});
            }
            manageStatusToDelete(id, false);
        }
        cleanCarUpdate();
    };

    const handleUpdateEquipment = (input: string, id: string, optionnal: boolean, isNew?: boolean) => {
        if (isNew && props.carUpdate.create.EquipmentsToCreate) {
            const toUpdate = props.carUpdate.create.EquipmentsToCreate.filter(item => item.id === id);
            if (toUpdate.length !== 0)
                toUpdate[0].Name = input;
        } else {
            if (!props.carUpdate.update.EquipmentsToUpdate)
                props.carUpdate.update.EquipmentsToUpdate = [];
            const toUpdate = props.carUpdate.update.EquipmentsToUpdate.filter(item => item.id === id);
            if (toUpdate.length !== 0)
                toUpdate[0].Name = input;
            else
                props.carUpdate.update.EquipmentsToUpdate.push({id: id, Name: input, Optionnal: optionnal});
            props.carUpdate.update.updated = true;
        }
    };

    return (
        <>
            <h4> {translator.decode(`dynamic.${props.title}`)}: {props.equipmentList?.length} </h4>
            <ul className={`${Styles.equipmentHolder}`}>
                {
                    equipment?.map((item) => { return <Equipment
                        disabled={props.disabled}
                        handleUpdate={(input: string) => handleUpdateEquipment(input, item.id, item.Optionnal, item.isNew)}
                        handleValid={(input: string) => handleValidEquipment(item.id, input)}
                        handleDelete={() => handleDeletEquipment(item.id, item.isNew)}
                        key={item.id}
                        equipment={item}
                        carUpdate={props.carUpdate}
                    />})
                }
                {
                    equipmentToAdd.map(item => {return <Equipment
                        disabled={props.disabled}
                        customClass={Styles.newEquipment}
                        handleUpdate={(input: string) => handleUpdateEquipment(input, item.id, item.Optionnal, item.isNew)}
                        handleValid={(input: string) => handleValidEquipment(item.id, input)}
                        handleDelete={() => handleDeletEquipment(item.id, item.isNew)}
                        key={item.id}
                        equipment={item}
                        carUpdate={props.carUpdate}
                    />})
                }

                { props.disabled?
                    <li>
                        <CreateEquipment addEquipment={(newItem: CarEquipmentType) => setEquipmentToAdd([...equipmentToAdd, newItem])} carUpdate={props.carUpdate} isOptional={props.title == "option" ? true : false} />
                    </li>
                    :null
                }

            </ul>
        </>
    );
};
